import './main-slider-item.scss'
import {connect} from "react-redux";
import {getPropsFromState} from "../../../../redux/mapStateToProps";
import {GetSliderHome, sendSubscribe} from "../../../../redux/actions";
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import {Autoplay, Navigation} from 'swiper/modules';
import {generateFileMediaUrl} from "../../../../utils/generateMediaUrl";
import Badge from "../../../../components/uiElements/badge/Badge";
import {PageLeftArrIcon, PageRightArrIcon} from "../../../../assets/images";
import {useRef, useState} from "react";
import {useHistory} from "react-router-dom";


function MainSliderItem(props) {
    const {sliderList,} = props
    const [isReady, setIsReady] = useState(false);

    const sliderRef = useRef();

    const handleSwiperInit = (swiper) => {
        sliderRef.current = swiper;
        setIsReady(true); // now it's safe to call swiper methods
    };

    function handlePrev() {
        if (isReady && sliderRef.current) {
            sliderRef.current?.slidePrev();
        }
    }

    function handleNext() {
        if (isReady && sliderRef.current) {
            sliderRef.current?.slideNext();
        }
    }


    return <div className={'main_slider_item_wrapper'}>
        <Swiper
            onSwiper={handleSwiperInit}
            spaceBetween={20}
            keyboard={{
                enabled: true,
            }}
            // centeredSlides={true}
            loop={true}
            autoplay={{
                delay: 2500,
                disableOnInteraction: true,
            }}
            navigation={false}
            modules={[Autoplay, Navigation]}
            className="main_slider_item_swiper_wrapper"
        >
            {
                sliderList?.map(item => {
                    return <SwiperSlide key={item.id}>
                        <SliderItem item={item}/>
                    </SwiperSlide>
                })
            }
        </Swiper>

        <div className={'swiper_custom_button swiper_custom_prev'}
             onClick={handlePrev}>
            <PageLeftArrIcon/>
        </div>
        <div className={'swiper_custom_button swiper_custom_next'}
             onClick={handleNext}>
            <PageRightArrIcon/>
        </div>
    </div>
}


const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'staticTexts',
        'requestLoading',
        'sliderHome',
        'contacts',
    ])
};
const mapDispatchToProps = {
    sendSubscribe,
    GetSliderHome,
};
export default connect(mapStateToProps, mapDispatchToProps)(MainSliderItem);


function SliderItem(props) {
    const {item} = props;
    const history = useHistory()

    const [imageLoaded, setImageLoaded] = useState(false);
    return <div className={'swiper_item_wrapper'} onClick={() => {
        if (item.link) {
            if (item.link.startsWith("http")) {
                window.open(item.link, "_blank")
            } else {
                history.push(item.link)
            }
        }
    }}>
        {
            item?.mediaMain?.detailPath || item?.mediaMain?.lightPath || item?.mediaMain?.path  ?   <img
                src={generateFileMediaUrl(item?.mediaMain?.detailPath || item?.mediaMain?.lightPath || item?.mediaMain?.path)}
                alt="slider item"
                onLoad={() => setImageLoaded(true)}
                loading="eager"/> : <div className={'slider_bg_gray'}/>
        }
        <div className={`
                gradient ${imageLoaded? "show":''}`}/>
        <div className={'swiper_item_info'}>
            <div className={'item_info_badge'}>
                {item?.badge && <Badge type={item?.badge}/>}
            </div>
            <div className={'item_info_title'}>
                {item.title || ""}
            </div>
            <div className={'item_info_description'}>
                {item.description || ""}

            </div>
        </div>
    </div>
}